import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Search, MessageSquare } from 'lucide-react';
import './GameTypeSelectorModal.css';

const GAME_TYPES = [
  {
    id: 'creative-coaster',
    label: 'Creative Coaster',
    description: 'Design challenge with sessions, client changes, and scoring. Set up designers, briefs, and bonus requirements.',
    icon: MessageSquare,
    color: '#8C2BFF',
  },
  {
    id: 'find-image',
    label: 'Find The Image',
    description: 'Race to spot the hidden object in an AI-generated scene. Quick setup with target selection and image generation.',
    icon: Search,
    color: '#D702F6',
  },
];

const GameTypeSelectorModal = ({ open, onOpenChange, onSelect }) => {
  const handleSelect = (gameType) => {
    onSelect(gameType);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="game-type-selector-modal">
        <button
          type="button"
          className="game-type-selector-close-x"
          onClick={() => onOpenChange(false)}
          aria-label="Close"
        >
          ×
        </button>
        <DialogHeader>
          <DialogTitle className="game-type-selector-title">
            Set Up New Game
          </DialogTitle>
          <DialogDescription className="game-type-selector-description">
            Choose which game you want to host, then follow the setup steps for that game.
          </DialogDescription>
        </DialogHeader>

        <div className="game-type-selector-cards">
          {GAME_TYPES.map((game) => {
            const Icon = game.icon;
            return (
              <button
                key={game.id}
                type="button"
                className="game-type-card"
                onClick={() => handleSelect(game.id)}
                style={{
                  '--card-accent': game.color,
                }}
              >
                <div className="game-type-card-icon" style={{ color: game.color }}>
                  <Icon size={32} strokeWidth={2} />
                </div>
                <h3 className="game-type-card-title">{game.label}</h3>
                <p className="game-type-card-description">{game.description}</p>
                <span className="game-type-card-cta">Set up game →</span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GameTypeSelectorModal;
